module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic14.f2c4fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic14.png
// module id = 513
// module chunks = 1